import { DocumentHistoryEntry, documentHistoryAtom } from "@/atoms/documentHistory";
import { DocumentHistoryUsecase } from "@/usecases/document-history/DocumentHistoryUsecase";
import { usePrivatePageContext } from "@/utils/hooks/private-page.hooks";
import { useAtom } from "jotai";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

export const useDocumentHistoryView = () => {
  const { t } = useTranslation();
  const { user } = usePrivatePageContext();
  const [documentHistory, setDocumentHistory] = useAtom(documentHistoryAtom);

  const [open, setOpen] = useState<boolean>(false);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState<boolean>(false);
  const [deleteEntry, setDeleteEntry] = useState<DocumentHistoryEntry>();
  const [deleteAllConfirmOpen, setDeleteAllConfirmOpen] = useState<boolean>(false);

  useEffect(() => {
    const loaded = DocumentHistoryUsecase.list(user.userId);
    setDocumentHistory(loaded);
  }, [user.userId, setDocumentHistory]);

  const grouped = useMemo(() => DocumentHistoryUsecase.groupByDate(documentHistory), [documentHistory]);

  const onClickTrash = useCallback((entry: DocumentHistoryEntry) => {
    setDeleteEntry(entry);
    setDeleteConfirmOpen(true);
  }, []);

  const callDeleteEntry = useCallback(() => {
    if (!deleteEntry) return;
    setDocumentHistory((prev) => DocumentHistoryUsecase.remove(user.userId, prev, deleteEntry));
    setDeleteEntry(undefined);
    setDeleteConfirmOpen(false);
  }, [deleteEntry, setDocumentHistory, user.userId]);

  const onClickDeleteAll = useCallback(() => {
    setDeleteAllConfirmOpen(true);
  }, []);

  const callDeleteAll = useCallback(() => {
    DocumentHistoryUsecase.removeAll(user.userId);
    setDocumentHistory([]);
    setDeleteAllConfirmOpen(false);
  }, [setDocumentHistory, user.userId]);

  return {
    t,
    documentHistory,
    grouped,
    open,
    setOpen,
    onClickTrash,
    deleteEntry,
    deleteConfirmOpen,
    setDeleteConfirmOpen,
    callDeleteEntry,
    onClickDeleteAll,
    deleteAllConfirmOpen,
    setDeleteAllConfirmOpen,
    callDeleteAll,
  };
};
